import { NameID } from "common/types/NameID";
import { MapArea } from "common/types/MapArea";
import {
  ChartBar,
  ChartOverlayData,
  ChartOverlayPin,
} from "common/components/map/common/osm/components/ChartOverlayDrawer";
import { PinData } from "common/components/map/common/osm/components/PinDrawer";
import { getPolygonLabelPosition } from "common/components/map/common/MapUtil";

export const useMapOverlay = () => {
  const addToOverlay = (
    overlayMap: Map<number, ChartOverlayData>,
    area: NameID,
    category: NameID,
    count: number,
    metaAreas: MapArea[],
    pin?: PinData,
  ) => {
    // 2段目以降
    if (overlayMap.has(area.id)) {
      const overlay = overlayMap.get(area.id)!;
      const bar = overlay.bars.find((b) => b.label.id === category.id);
      if (bar) bar.count += count;
      else overlay.bars.push({ label: category, count });
      if (pin) {
        const overlayPin: ChartOverlayPin = { categoryId: category.id, data: pin };
        overlay.pin = [...(overlay.pin ?? []), overlayPin];
      }
      return;
    }

    // 1段目の場合
    if (area.id >= 0) {
      // 通常はバーの表示位置をポリゴンの中心座標にする
      const mapArea = metaAreas.find((ma) => ma.area.id === area.id);
      if (!mapArea?.polygon?.coords || mapArea.polygon.coords.length < 3) return;
      const center = getPolygonLabelPosition(
        mapArea.polygon.coords.map((c) => ({ x: c.x, y: c.y, z: c.z })),
      );
      if (!center) return;

      const bars: ChartBar[] = [{ label: category, count }];
      const pins = pin ? [{ categoryId: category.id, data: pin }] : undefined;
      overlayMap.set(area.id, { area, center, bars, pin: pins });
    } else {
      // その他は枠外に表示するため座標は無し
      const bars: ChartBar[] = [{ label: category, count }];
      const pins = pin ? [{ categoryId: category.id, data: pin }] : undefined;
      overlayMap.set(area.id, { area, center: { x: 0, y: 0 }, bars, pin: pins });
    }
  };

  return { addToOverlay };
};
